import React, { useState } from "react";
import { CustomButton, CustomDialog, CustomIconButton, icon } from "../../../../../../common/components";
import styles from "./ViewRow.module.css";
import { translate } from "../../../../../../common/providers";

function applyThen() {
	return new Promise((resolve) => {
		resolve();
	});
}
export default function ViewRow({ view, onDelete, onDuplicate, onOpenEdition, onSelectPanel }) {
	const { id, name, fields, projects, companies } = view;
	const [isDuplicating, setIsDuplicating] = useState(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const handleOpenDeleteDialog = () => {
		setOpenDeleteDialog((prev) => !prev);
	};
	const handleDelete = () => {
		if (onDelete && typeof onDelete === "function" && view.id) {
			onDelete(view.id);
		}
	};
	const handleDuplicate = () => {
		if (onDuplicate && typeof onDuplicate === "function" && view.id) {
			setIsDuplicating(true);
			applyThen();
		}
	};
	const handleOpenEdition = () => {
		onOpenEdition(view);
	};
	return (
		<div key={id} className={styles.row}>
			<div>
				<span>{name}</span>
			</div>
			<div>
				<CustomButton variant="outlined" onClick={() => onSelectPanel({ panel: "criteria", row: view })}>
					{fields}
				</CustomButton>
			</div>
			<div>
				<CustomButton variant="outlined" onClick={() => onSelectPanel({ panel: "projects", row: view })}>
					{projects}
				</CustomButton>
			</div>
			<div>
				<CustomButton variant="outlined" onClick={() => onSelectPanel({ panel: "companies", row: view })}>
					{companies}
				</CustomButton>
			</div>
			<div className={styles.actions}>
				<CustomIconButton
					icon={icon.faPenToSquare}
					size="sm"
					tooltip={translate("common:btn.edit")}
					variant="outlined"
					onClick={handleOpenEdition}
				/>
				<CustomIconButton
					disabled={isDuplicating}
					icon={icon.faCopy}
					size="sm"
					tooltip={translate("dsi.form-studio.row-action.duplicate")}
					variant="outlined"
					onClick={handleDuplicate}
				/>
				<CustomIconButton
					icon={icon.faTrash}
					size="sm"
					tooltip={translate("common:btn.delete")}
					variant="outlined"
					onClick={handleOpenDeleteDialog}
				/>
			</div>
			<CustomDialog
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={openDeleteDialog}
				subTitle={translate("dsi.form-studio.view.deletion.confirmation-text")}
				title={translate("common:delete-confirmation-popup.title")}
				onClose={handleOpenDeleteDialog}
				onSubmit={handleDelete}
			/>
		</div>
	);
}
